/**
 * Formats a Unix timestamp (ms) as a relative time string.
 *
 * - < 60 seconds: "{n}s ago"
 * - < 60 minutes: "{n}m ago"
 * - >= 60 minutes: "{n}h ago"
 *
 * Returns "—" if the timestamp is 0 or NaN.
 */
export function formatRelativeTime(timestamp: number): string {
  if (!timestamp || isNaN(timestamp)) {
    return '—'
  }

  const now = Date.now()
  const diffMs = now - timestamp
  const diffSeconds = Math.floor(diffMs / 1000)

  if (diffSeconds < 60) {
    return `${diffSeconds}s ago`
  }

  const diffMinutes = Math.floor(diffSeconds / 60)
  if (diffMinutes < 60) {
    return `${diffMinutes}m ago`
  }

  const diffHours = Math.floor(diffMinutes / 60)
  return `${diffHours}h ago`
}
